<template>
<div class="section">
  <div class="section__header">
    <h2>Мои классы</h2>
    <back></back>

    <div class="section__menu header-menu">
      <button type="button" class="header-menu__btn" @click="openPopup('AddClass', null)">
        <i class="fas fa-plus-circle"></i>
        Добавить класс
      </button>
      <!-- <router-link to="/hw-archive" class="header-menu__btn">
        <i class="fas fa-archive"></i>
        Архив ДЗ
      </router-link> -->
    </div>
  </div>

  <div class="section__body">
    <Sort class="sort" :sortTypes="sortTypes" />

    <ul class="wh-block__items">
      <li v-for="item in sortedItems" :key="item.id" class="class-item">
        <router-link :to="'/class/' + item.id" class="class-link">
          <strong>{{ item.title }}</strong><br>
          <span>{{ stringDesc(item.desc) }}</span><span v-if="item.desc && item.day">, </span>
          <span>{{ item.day }}</span><span v-if="item.time">, {{ item.time }}</span>
        </router-link>
        <button 
          type="button" 
          class="header-menu__btn header-menu__btn--remove" 
          @click="onRemoveClass(item)"
        >
          <i class="fas fa-trash-alt"></i>
          Удалить
        </button>
      </li>
    </ul>
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        @close-popup="popupIsOpened = false"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import AddClass from './classes/AddClass'
import { sort_mix } from '../../mixins/sort_mix'
import { popup_mix } from '../../mixins/popup_mix'
import { mapGetters, mapMutations } from 'vuex'

export default {
  inject: ['http'],
  mixins: [ sort_mix, popup_mix ],
  name: "classes",
  data() {
    return {
      sortTypes: {
        'day': 'По дню недели',
        'title': 'По алфавиту'
      }
    }
  },
  components: {
    AddClass
  },
  computed: {
    ...mapGetters({
      items: 'teacher/classes'
    })
  },
  methods: {
    ...mapMutations({
      removeClass: 'teacher/removeClass'
    }),
    stringDesc(s) {
      return s.replace(/<\/?[a-zA-Z]+>/gi, '');
    },
    onRemoveClass(item) {
      swal({
          title: 'Внимание!',
          text: `Вы действиетельно ходите удалить класс ${item.title}?`,
          icon: "warning",
          buttons: ['Отмена', 'Да'],
        })
        .then((choise) => {
          if (choise) {
            this.http.post('onDeleteClass ', {
                id: item.id
              }).then(() => {
                this.removeClass(item.id)
                swal('Успешно!', `Класс ${item.title} удален`, 'success')
              })
              .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  align-items: center;

  &:hover {
    background-color: #fff;
  }
}

.class-link {
  flex-grow: 1;
}

.wh-block__items {
  margin-top: 20px;
  width: 100%;
}
.class-item .header-menu__btn {
  font-size: 12px;
}
</style>
